import { createContext, ReactNode, useMemo } from 'react';
import { Status, Variable } from '@restworld/utility-types';
import { useVariableOptions, useStatusOptions } from '../hooks';

const GlobalOptionsFetchingContext = createContext<GlobalOptionsFetchingContextProps | null>(null);
const GlobalOptionsFetchingProvider = ({ children }: GlobalProviderProps) => {
  const { loading: variableOptionLoading, fetchVariable, variableOptions } = useVariableOptions();
  const { loading: statusOptionLoading, fetchStatus, statusOptions } = useStatusOptions();
  const isLoading = useMemo(
    () => variableOptionLoading || statusOptionLoading,
    [statusOptionLoading, variableOptionLoading]
  );
  return (
    <GlobalOptionsFetchingContext.Provider
      value={{
        fetchVariable,
        fetchStatus,
        statusOptions,
        variableOptions,
        isLoading,
      }}
    >
      {children}
    </GlobalOptionsFetchingContext.Provider>
  );
};
export { GlobalOptionsFetchingProvider, GlobalOptionsFetchingContext };
// --> types
export interface GlobalOptionsFetchingContextProps {
  fetchVariable: (variableName: string[]) => void;
  fetchStatus: (prefix: string[]) => void;
  statusOptions?: StatusOptionType;
  variableOptions?: VariableOptionType;
  isLoading?: boolean;
}
type GlobalProviderProps = {
  children: ReactNode;
};
type VariableOptionType = {
  [variableName: string]: Variable[];
};
type StatusOptionType = {
  [prefix: string]: Status[];
};
